import { FC, memo } from 'react'

import { FieldSet } from 'ui/components/FieldSet'
import { Validators } from 'ui/components/Form'
import { Hr } from 'ui/components/Hr'
import { TextInput, TextareaInput, USPhoneInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { CompaniesBeingHeld } from './CompaniesBeingHeld'
import { RelationshipsProps } from './RelationshipsProps'

import * as SC from './styles'

export const Relationships: FC<RelationshipsProps> = memo((props) => {
  const { Field, companyData } = props
  const { customerStatusOptions, selectedSubsidiaries } = companyData

  const leftSideFields = [
    <Field
      required
      name="name"
      label="Company Name"
      input={TextInput}
      inputProps={{
        'data-qa': 'Company Name'
      }}
      validator={Validators.required.string}
    />,
    <Field
      name="legalName"
      label="Entity Legal Name"
      input={TextInput}
      inputProps={{
        'data-qa': 'Entity Legal Name'
      }}
    />,
    <Field
      name="dba"
      label="DBA"
      input={TextInput}
      inputProps={{
        'data-qa': 'DBA'
      }}
    />,
    <Field
      required
      name="customerStatus"
      label="Customer Status"
      input={Select}
      inputProps={{
        'data-qa': 'Customer Status',
        'options-data-qa': 'input options',
        data: customerStatusOptions
      }}
      validator={Validators.required.field}
    />
  ]

  const rightSideFields = [
    <Field
      name="holdingGroupCompaniesIDs"
      input={CompaniesBeingHeld}
      label="Subsidiaries"
      inputProps={{
        selectedSubsidiaries
      }}
    />,
    <Field
      name="phone"
      label="Phone"
      input={USPhoneInput}
      inputProps={{
        'data-qa': 'Phone'
      }}
    />,
    <Field
      name="website"
      label="Website"
      input={TextInput}
      inputProps={{
        'data-qa': 'Website'
      }}
    />
  ]

  return (
    <FieldSet legend="Relationship Details">
      <SC.RowsWrapper>
        {new Array(Math.max(leftSideFields.length, rightSideFields.length)).fill(0).map((_, field_index) => (
          <FormRow key={field_index}>
            <Col>{leftSideFields[field_index] || <div />}</Col>
            <Col>{rightSideFields[field_index] || <div />}</Col>
          </FormRow>
        ))}
      </SC.RowsWrapper>
      <FormRow>
        <Col2x>
          <Field
            name="internalNotes"
            label="Notes"
            input={TextareaInput}
            inputProps={{
              'data-qa': 'Notes'
            }}
          />
        </Col2x>
      </FormRow>
      <Hr />
    </FieldSet>
  )
})
